import { computed, ref } from 'vue'
import { useGeoDataMapInteractions } from '@composables/useGeoDataMapInteractions'
import { buildGeoDataMapLayerConfig } from '@utils/geoDataMapLayerConfig'
import { validateGeoDataMapResponse } from '@utils/validateGeoDataMapResponse'
import {
  ELEMENT_SCREENSHOT_MAPBOX_COMPATIBLE_CONFIGURATION,
  MAX_ZOOM,
  MIN_ZOOM,
  MAP_ZOOM_DEFAULT,
  SOURCE_ID_POINTS,
  SOURCE_ID_POLYGONS,
  SOURCE_ID_POLYGON_CENTROIDS
} from '@root/constants'

const POPUP_CONFIG = { anchor: 'top' }

const SOURCE_KEYS = {
  points: SOURCE_ID_POINTS,
  polygons: SOURCE_ID_POLYGONS,
  polygonCentroids: SOURCE_ID_POLYGON_CENTROIDS
}

export function useGeoDataMap(props, { env, store }) {
  const screenIsDesktop = computed(() => store.getters['screenSize/isDesktop'])
  const errorMessages = ref(validateGeoDataMapResponse(props.geoJson, props.translations))

  const configuration = {
    accessToken: env.mapbox.accessToken,
    style: env.mapbox.mapStyle,
    zoom: MAP_ZOOM_DEFAULT,
    minZoom: MIN_ZOOM,
    maxZoom: MAX_ZOOM,
    scrollZoom: !!store.getters['screenSize/isDesktop'],
    ...ELEMENT_SCREENSHOT_MAPBOX_COMPATIBLE_CONFIGURATION
  }

  const {
    popUpLngLat,
    iccaInfo,
    showPolygonDiamondLegend,
    onMapLoad,
    closePopup
  } = useGeoDataMapInteractions({
    getPolygonFeatures: () => props.geoJson.data.polygons.features,
    store
  })

  const baseConfigurations = buildGeoDataMapLayerConfig(props.geoJson.data)

  const bannerProps = computed(() => ({
    translations: props.translations,
    privacyPolicyLink: props.privacyPolicyLink,
    dataCollectionTermsLink: props.dataCollectionTermsLink
  }))

  return {
    screenIsDesktop,
    errorMessages,
    errorMessagesTranslation: props.translations.error_messages,
    configuration,
    sourceKeys: SOURCE_KEYS,
    popupConfig: POPUP_CONFIG,
    baseConfigurations,
    bannerProps,
    popUpLngLat,
    iccaInfo,
    showPolygonDiamondLegend,
    onMapLoad,
    closePopup
  }
}
